// src/config/appConfig.js

const getEnv = (key) => {
  if (window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }
  return process.env[key];
};

export const appBaseName        = getEnv("REACT_APP_BASE_NAME");
export const appAdminModuleName = getEnv("REACT_APP_ADMIN_MODULE_NAME");
export const appBaseUrl         = getEnv("REACT_APP_BASE_URL");
export const appApiUrl          = getEnv("REACT_APP_API_URL");
export const appVersion         = getEnv("REACT_APP_VERSION");
export const appEnv             = getEnv("REACT_APP_ENV");